import { fetchPDFReportUrl } from '../../actions/reports';
import { ThunkDispatch } from '../../actions/utils';
import t from '../../localization/i18n';

const openEmailClient = (
    englishPDFUrl: string,
    frenchPDFUrl: string,
    subjectText: string
) => {
    if (englishPDFUrl && frenchPDFUrl) {
        const urlSearchParams = new URLSearchParams();

        const englishUrl = `${t('email.englishPDFUrl')}:\r\n\r\n${englishPDFUrl}`;
        const frenchUrl = `${t('email.frenchPDFUrl')}:\r\n\r\n${englishPDFUrl}`;
        urlSearchParams.append('subject', subjectText);
        urlSearchParams.append('body', `${englishUrl}\r\n\r\n${frenchUrl}\r\n\r\n`);
        const mailtoLink = `mailto:?${urlSearchParams.toString()}`;

        // nosemgrep: eslint.detect-non-literal-fs-filename
        window.open(mailtoLink, '_blank');
    }
};

const fetchReportUrlAndOpenEmail = (
    dispatch: ThunkDispatch,
    latestReportId: string,
    subjectText: string
) => {
    let englishPDFUrl = '';
    let frenchPDFUrl = '';
    dispatch(fetchPDFReportUrl(latestReportId, 'en-US'))
        .then((resp) => {
            englishPDFUrl = resp.data.reportUrl;
        })
        .then(() => dispatch(fetchPDFReportUrl(latestReportId, 'fr-CA')).then((resp) => {
            frenchPDFUrl = resp.data.reportUrl;
        }))
        .then(() => openEmailClient(englishPDFUrl, frenchPDFUrl, subjectText))
        .catch(() => console.error(t('errorMessages.emailGenerationError')));
};

export default fetchReportUrlAndOpenEmail;
